;{
    window.packageInfo = window.packageInfo || {};
    window.packageInfo['ipscorecombined'] = {
      info: 'Infor Public Sector v11.2.2',
      date: '1742861844504',
      revisionNumber: '2'
    };
  };